export default {
  columns: {
    title: 'Titolo',
    image: 'Immagine',
    button_url: 'URL pulsante',
    button_text: 'Testo pulsante',
    description: 'Descrizione',
    visible: 'Visibile',
    actions: 'Azioni',
  },
  buttons: {
    create_post: 'Crea post',
    edit: 'Modifica',
    delete: 'Elimina',
    cancel: 'Annulla',
    confirm: 'Conferma',
  },
  title: 'Post in evidenza',
  delete_confirmation: 'Sei sicuro di voler eliminare questo post?',
};
